import React from 'react';

import { Link } from 'gatsby';

import CDNImage from '../cdn-image';

import '../../../styles/common/promos/christmas-banner.scss';

const ChristmasBanner = (props) => (
  <>
    {(props.path.substr(0, 5) !== '/shop' &&
      props.path.substr(0, 8) !== '/product') ? (
        <div role="complementary" aria-label="Promotional Banner" className="sitewide-banner christmas-banner">
          <Link to="/shop/fine-art-prints">
            <div className="contents page-width">
              <span className="left-side">
                <div className="images">
                  <div>
                    <CDNImage
                      imagePath="/banners/christmas-prints/shadows.jpg"
                      height="360"
                      alt="Eight Shadow Figures print"
                    />
                  </div>
                  <div>
                    <CDNImage
                      imagePath="/banners/christmas-prints/mississippi.jpg"
                      height="360"
                      alt="Ancient Courses print"
                    />
                  </div>
                </div>
              </span>
              <span className="details">
                <span className="headline">
                  Give the gift of a PDR print this holiday season
                </span>

                <span className="cta-button">
                  Explore Our Prints
                </span>

                <span className="footer">
                  <u>Last orders for delivery by 25 Dec:</u> US/Canada: 30 Nov (Framed), 7 Dec (Unframed)<br />
                  UK: 3 Dec (Framed), 13 Dec (Unframed) / EU: 22 Nov (Framed), 3 Dec (Unframed)<br />
                  Australia: 28 Nov (Framed + Unframed) / Elsewhere: 22 Nov (Framed + Unframed)
                </span>
              </span>
              <span className="right-side">
                <div className="images">
                  <div>
                    <CDNImage
                      imagePath="/banners/christmas-prints/blue-root-2.jpg"
                      height="360"
                      alt="Blue Root print"
                    />
                  </div>
                  <div>
                    <CDNImage
                      imagePath="/banners/christmas-prints/comet.jpg"
                      height="360"
                      alt="Wanderings of a Comet print"
                    />
                  </div>
                </div>
              </span>
            </div>
          </Link>
        </div>
    ) : null}
  </>
);

export default ChristmasBanner;
